import { loginWithGithubCode, startGithubLogin, type LoginResp } from "../api/overlordAuthApi";
import { clearAuthReturnTo, saveAuthReturnTo } from "./authReturnTo";
import { resolveGithubRedirectUri } from "./githubRedirectUri";
import { clearGithubAuthState, consumeGithubAuthState, saveGithubAuthState } from "./githubState";

let githubCallbackLoginPromise: Promise<LoginResp> | null = null;

// returnTo: 로그인 전에 가려던 앱 내부 경로. 없으면 로그인 후 기본 목적지로 간다.
export async function beginGithubRedirectLogin(returnTo?: string): Promise<void> {
  resetGithubRedirectLogin();
  clearGithubAuthState();

  // 이전 시도에 남은 목적지가 이번 로그인을 엉뚱한 곳으로 보내지 않게 항상 새로 정한다.
  if (returnTo === undefined) {
    clearAuthReturnTo();
  } else {
    saveAuthReturnTo(returnTo);
  }

  const startResp = await startGithubLogin(resolveGithubRedirectUri());
  saveGithubAuthState(startResp.state);
  window.location.assign(startResp.authorize_url);
}

export function completeGithubRedirectLogin(search = window.location.search): Promise<LoginResp> {
  githubCallbackLoginPromise ??= completeGithubRedirectLoginOnce(search);
  return githubCallbackLoginPromise;
}

export function resetGithubRedirectLogin(): void {
  githubCallbackLoginPromise = null;
}

async function completeGithubRedirectLoginOnce(search: string): Promise<LoginResp> {
  const { code, state } = parseGithubCallbackSearch(search);
  const storedState = consumeGithubAuthState();

  if (storedState === null) {
    throw new Error("GitHub 로그인 요청 정보를 찾지 못했습니다. 다시 로그인해 주세요.");
  }

  if (storedState !== state) {
    throw new Error("GitHub 로그인 응답을 확인하지 못했습니다. 다시 로그인해 주세요.");
  }

  return loginWithGithubCode({ code, state });
}

function parseGithubCallbackSearch(search: string): { code: string; state: string } {
  const params = new URLSearchParams(search);
  const code = readRequiredCallbackParam(params, "code");
  const state = readRequiredCallbackParam(params, "state");

  return { code, state };
}

function readRequiredCallbackParam(params: URLSearchParams, key: "code" | "state"): string {
  const value = params.get(key)?.trim();
  if (!value) {
    throw new Error("GitHub 로그인 응답에 필요한 값이 없습니다. 다시 로그인해 주세요.");
  }

  return value;
}
